import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APPLICATION_CONFIGURATION_URL } from '@com-delta-idp/angular-core/environment/tokens';
import { Observable, of } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { AppConfigMap } from '../../../../models/utils/common.interfaces';
import { Config } from '../../../../models/utils/config.interfaces';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private _idpConfig!: AppConfigMap;
  private _appConfigInitializer$: Observable<AppConfigMap>;

  constructor(
    private httpClient: HttpClient,
    @Inject(APPLICATION_CONFIGURATION_URL) private appConfigUrl: string
  ) {
    this._appConfigInitializer$ = this.buildInitializerRequest();
  }

  /**
   * Initialize the config object by requesting (idp-config.json) from AEM
   */
  initializeAppConfig(): Observable<AppConfigMap> {
    return this._appConfigInitializer$;
  }

  buildInitializerRequest(): Observable<AppConfigMap> {
    if (this.appConfigUrl) {
      return this.httpClient.get<AppConfigMap>(this.appConfigUrl).pipe(
        switchMap((responseAppConfig: AppConfigMap) => {
          if (
            responseAppConfig &&
            Object.entries(responseAppConfig).length > 0
          ) {
            this._idpConfig = responseAppConfig;
            return of(this._idpConfig);
          } else {
            return of({} as AppConfigMap);
          }
        }),
        shareReplay(1)
      );
    } else {
      return of({} as AppConfigMap);
    }
  }

  /**
   * Return value by key from the config object (idp-config.json)
   */
  getConfigValue(appName: string, key: string): Observable<string> {
    if (this._idpConfig) {
      // Use cached value
      return this._idpConfig && this._idpConfig[appName]
        ? of(this._idpConfig[appName][key])
        : of('unavailable config');
    } else {
      // Call initializer
      return this.initializeAppConfig().pipe(
        switchMap((appConfig) => {
          if (appConfig && appConfig[appName]) {
            return of(appConfig[appName][key]);
          } else {
            return of('unavailable config');
          }
        })
      );
    }
  }

  getConfig(key: string): Config {
    return this._idpConfig[key];
  }
}
